import moment from "moment";
import axios from "axios";
import store from "@/store";
import { DequeueCallException, EnqueueCallException } from "./exceptions";

export const QUEUE_ACTION_ENQUEUE = "enqueue";
export const QUEUE_ACTION_DEQUEUE = "dequeue";
export const QUEUE_ACTION_CLEAR = "clear";

class PhoneCall {
	callDetails = null;
	recordingSid = null;
	_duration = 0;
	_onHold = false;
	direction = null;

	constructor(callInstance, inbound, parameters) {
		this.callInstance = callInstance;

		this.callDetails = {
			...Object.fromEntries(
				Object.entries(parameters ?? {}).filter(([_, v]) => v !== undefined)
			),
			...(callInstance.customParameters
				? Object.fromEntries(
					Array.from(callInstance.customParameters).filter(([_, v]) => v !== undefined)
				)
				: {}
			)
		};

		if (inbound) {
			this.callDetails.phoneNumber = callInstance.parameters?.From;
		} else {
			this.callDetails.phoneNumber = parameters?.patientPhone ?? parameters?.To;
		}

		store.commit("voice/setCallDetails", this.callDetails);
	};

	mute = (muteToggle) => {
		this.callInstance?.mute(muteToggle);
	};

	countDuration = () => {
		if (durationTimer) clearInterval(durationTimer);
		var durationTimer = setInterval(() => {
			this._duration++;
		}, 1000);
	};

	onCall =  () => {
		store.commit("voice/setIsOnCall", true);
	};

	answered = (interval) => {
		if (interval) {
			clearInterval(interval);
		}
		store.commit("voice/acceptCall");
	};

	accept = () => {
		this.callInstance?.accept();
	};

	hangUp = () => {
		this.callInstance?.disconnect();
		if (this.callId) {
			store.commit("calls/releaseCall", this.callId);
		}
	};

	reject = () => {
		this.callInstance?.reject();
		if (this.callId) {
			store.commit("calls/releaseCall", this.callId);
		}
	};

	rejectAll = () => {
		this.callInstance?.reject();
		if (this.callId) {
			store.commit("calls/releaseCall", this.callId);
		}

		if (this.direction === "inbound") {
			// Reject all other calls
			try {
				axios.post("voice/v1/calls/rejectAll", {
					callId: this.callId
				});
			} catch (error) {
				console.error(error);
			}
		}
	};

	resume = async () => {
		try {
			this._onHold = false;
			//	this.mute(false);

			await axios.post("voice/v1/calls/resume", {
				callId: this.callId
			});
		} catch (err) {
			throw new DequeueCallException(`Failed to resume call: ${this.callId}`);
		}
	};

	hold = async () => {
		try {
			await axios.post("voice/v1/calls/hold", {
				callId: this.callId
			});

			this._onHold = true;
		//	this.mute(true);
		} catch (err) {
			throw new EnqueueCallException(`Failed to enqueue call ${this.callId}`);
		}
	};

	async transferExternalCall(extensionId) {

		try {
			await axios.post("voice/v1/calls/transfer", {
				callId: this.callId,
				to: `ext.${extensionId}`
			});
		} catch (error) {
			console.error(error);
			this.$error(this.$t("error.transfer-call"));
		}
	}

	async transferCall(group, userClient, userSip) {
		// If the userClient is assigned to a sip, both phones will ring (client, sip);

		try {
			await axios.post("voice/v1/calls/transfer", {
				callId: this.callId,
				to: userClient || userSip || group?.phone,
				toUserGroup: group?.id
			});
		} catch (error) {
			console.error(error);
			this.$error(this.$t("error.transfer-call"));
		}
	}

	async parkCall() {
		try {
			if (this.callId) {
				await axios.post(`voice/v1/queues/park/${this.callId}`);
			}
		} catch (error) {
			this.$error(this.$t("error.send-call-to-queue"));
		}
	}

	get duration() {
		return moment.utc(this._duration * 1000).format("mm:ss");
	}

	get status() {
		return this.callInstance?.status();
	}

	get onHold() {
		return this._onHold;
	}

	get callSid() {
		return this.callInstance?.parameters?.CallSid;
	}

	get callId() {
		return this.callDetails?.id;
	}
}

export default PhoneCall;
